
import { of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { LogEntry } from "../logEntry";
import { LogPublisher } from "./log-publisher";


export class LogConsole extends LogPublisher {
    
    
    log(entry: LogEntry): Observable<boolean> {
        // Log to console
        console.log(entry.buildLogString());
        return of(true);
    }
    
    clear(): Observable<boolean> {
        console.clear();
        return of(true);
    }
}
